import { Link } from "react-router-dom";
import { FileText } from "lucide-react";
import logoImg from "@/assets/logo.jpg";
import { useLocale } from "@/contexts/LocaleContext";

const Footer = () => {
  const { t } = useLocale();
  return (
    <footer className="border-t border-border py-12 bg-card">
      <div className="container">
        <div className="flex flex-col md:flex-row items-center justify-between gap-6">
          <div className="flex items-center gap-2">
            <img src={logoImg} alt="DocSeal" className="w-7 h-7 rounded-lg object-contain" />
            <span className="font-display font-bold text-sm">DocSeal</span>
          </div>
          <p className="text-xs text-muted-foreground">
            {t.footer.tagline}. © {new Date().getFullYear()} DocSeal. All rights reserved.
          </p>
          <div className="flex items-center gap-6 text-xs text-muted-foreground">
            <Link to="/verify" className="hover:text-foreground transition-colors">{t.footer.verify}</Link>
            <Link to="/privacy" className="hover:text-foreground transition-colors">{t.footer.privacy}</Link>
            <Link to="/terms" className="hover:text-foreground transition-colors">{t.footer.terms}</Link>
            <Link to="/contact" className="hover:text-foreground transition-colors">{t.footer.contact}</Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
